import React from 'react'
import BookingTabs from './BookingTabs/BookingTabs'
import ProfileDetails from './ProfileDetails/ProfileDetails'
import NavigationButtons from '../../Template/NavigationButtons/NavigationButtons'
import './MyProfile.css'

const MyProfile = () => {
  return (
    <div className="my-profile-container">
        <NavigationButtons />
        <ProfileDetails/>
        <BookingTabs/>
    </div>
  )
}

export default MyProfile